import { stringify } from 'query-string';
import DefaultMapper, { toPagingAndSorting } from '../../dataProvider/DefaultMapper';
import { API_BASE_PATH_ADMIN } from '../../constants';

class WalletAccountItemMapper extends DefaultMapper {
	mapResource({ resource }) {
		return 'wallet/wallets/accounts';
	}

	prepareGetOne({ type, resource, params, options, mappedResource }) {
		options.url = `${API_BASE_PATH_ADMIN}/${mappedResource}/items/${params.id}`;
	}

	prepareGetList({ type, resource, params, options, mappedResource }) {
		const query = {
			...params.filter,
			...toPagingAndSorting(params)
		};
		options.url = `${API_BASE_PATH_ADMIN}/${mappedResource}/${params.filter.id}/items?${stringify(query)}`;
	}
}

export default WalletAccountItemMapper;
